const nav = {
	el: {
		body: document.body,
		header: document.querySelector('.header'),
		nav: document.querySelector('.nav'),
		navLower: document.querySelector('.nav__lower'),
		navItem: document.querySelectorAll('.nav__item'),
		navBack: document.querySelectorAll('.js-back-first-level'),
		subNav: document.querySelectorAll('.nav__wrap'),
		subNavHeading: document.querySelectorAll('.nav__subheading'),
		subNavItem: document.querySelectorAll('.nav__subitem'),
		subNavBack: document.querySelectorAll('.js-back-second-level'),
		subSubNav: document.querySelectorAll('.nav__menuwrap'),
		aside: document.querySelector('.aside')
	},

	vars: {
		extraLargeAndUp: window.matchMedia('(min-width: 80em)')
	},

	fxNavToggle() {
		this.el.nav.addEventListener('click', e => {
			if (e.target.classList.contains('nav') || e.target.classList.contains('nav__hamburger')) {
				!this.el.header.classList.contains('header--fixed') ? this.el.header.classList.add('header--fixed') : ''
				this.el.body.classList.toggle('no-scroll-hidden')
				this.el.nav.classList.toggle('is-nav-open')
				this.el.subNav.forEach(el => el.classList.remove('is-second-level', 'is-third-level'))
				this.el.navItem.forEach(el => el.removeAttribute('style'))
				this.el.subNavItem.forEach(el => el.removeAttribute('style'))
				this.el.navLower.removeAttribute('style')
				if (this.el.aside) {
					this.el.aside.classList.toggle('is-nav-open')
					this.el.aside.classList.contains('is-nav-open') ? this.el.aside.classList.remove('is-nav-open') : ''
				}
			}
		})
	},

	fxNavBack(el, classRemove) {
		el.forEach(el => el.addEventListener('click', e => {
			e.stopPropagation()
			this.el.navLower.removeAttribute('style')

			if (classRemove === 'is-third-level') {
				this.el.subSubNav.forEach(el => el.style.right = '-100%')
				setTimeout(() => {
					this.el.subNav.forEach(el => el.classList.remove(classRemove))
					this.el.subSubNav.forEach(el => el.removeAttribute('style'))
					this.el.subNavItem.forEach(el => el.removeAttribute('style'))
				}, 500)
			}
			else {
				this.el.subNav.forEach(el => el.classList.remove(classRemove))
				this.el.navItem.forEach(el => el.removeAttribute('style'))
			}
		}))
	},

	events() {
		if (this.vars.extraLargeAndUp.matches) {
			//open submenu on hover
			this.el.navItem.forEach(el => el.addEventListener('mouseenter', e => {
				this.el.subNav.forEach(el => el.classList.remove('is-hovered'))
				e.currentTarget.querySelector('.nav__wrap') && e.currentTarget.querySelector('.nav__wrap').classList.add('is-hovered')
			}))

			//close menu on hover
			this.el.header.addEventListener('mouseleave', () => this.el.subNav.forEach(el => el.classList.remove('is-hovered')))
			this.el.navLower.addEventListener('mouseenter', () => this.el.subNav.forEach(el => el.classList.remove('is-hovered')))
		}

		else {
			this.el.navItem.forEach(el => el.addEventListener('click', e => {
				if (e.currentTarget.querySelector('.nav__wrap')) {
					this.el.navLower.style.display = 'none'
					this.el.navItem.forEach(el => el.style.position = 'static')
					this.el.subNav.forEach(el => el.classList.remove('is-second-level'))
					e.currentTarget.querySelector('.nav__wrap').classList.add('is-second-level')
				}
			}))

			this.el.subNavItem.forEach(el => el.addEventListener('click', e => {
				this.el.subNavItem.forEach(el => el.style.display = 'none')
				e.currentTarget.style.cssText = 'display: block; position: static;'
				this.el.subNav.forEach(el => el.classList.remove('is-second-level', 'is-third-level'))
				e.currentTarget.closest('.nav__wrap').classList.add('is-second-level', 'is-third-level')
			}))
		}

	},
	init() {
		this.fxNavBack(this.el.navBack, 'is-second-level')
		this.fxNavBack(this.el.subNavBack, 'is-third-level')
		this.fxNavToggle()
		this.events()
	}
}

nav.init()